// 캠페인 ID 화이트리스트는 콤마구분 문자열 env 로 주입된다.
// 문자열 .includes() 부분일치(예: '546,547'.includes('54') === true) 오탐을 막기 위해
// 반드시 숫자 배열로 파싱 후 정확일치로 비교한다.
function parseCampaignList(raw){
    if(raw == null) return []
    return raw.split(',')
        .map(s => Number(s.trim()))
        .filter(n => Number.isSafeInteger(n) && n > 0)
}
function isCampaignInList(raw, campaign_id){
    if(campaign_id == null) return false
    const id = Number(campaign_id)
    if(!Number.isSafeInteger(id) || id <= 0) return false
    return parseCampaignList(raw).includes(id)
}
function check_is_hyundai(campaign_id){
    return isCampaignInList(process.env.VUE_APP_CAMPAIGN_LIST_HYUNDAI, campaign_id)
}
function check_is_ksteel(campaign_id){
    return isCampaignInList(process.env.VUE_APP_CAMPAIGN_LIST_KSTEEL, campaign_id)
}
function check_is_supply(campaign_id){
    return isCampaignInList(process.env.VUE_APP_CAMPAIGN_LIST_SUPPLY, campaign_id)
}

export { check_is_hyundai, check_is_ksteel, check_is_supply}
